import React, { useState } from "react";
// import FileViewPopup from "../../FileViewPopup";
import FilePdfOutlined from "../image/FilePdfOutlined";
import FileWordOutlined from "../image/FileWordOutlined";
import FileImageOutlined from "../image/FileImageOutlined";
import FileExcelOutlined from "../image/FileExcelOutlined";
import fileStore from "../../store/fileStore";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import CloseIcon from "../image/CloseIcon";
import PDFViewer from "../PDFViewer/PDFViewer";
import { findViewFile, getExtensionFile } from "../../utils/common";
import { ShareIos } from "iconoir-react";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const FileItem = (props) => {
    const { file, file_id, file_name, file_type, deleted, noAction } = props;

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = (e) => {
        setOpen(true);
    };

    const handleClose = (e) => {
        e.stopPropagation();
        setOpen(false);
    };

    const isFileTruc = window.location.pathname.includes("messages");
    const isFileVIMCToTruc =
        window.location.pathname.includes("connected-document");

    let iconFile = <FileImageOutlined />;
    if (file_type === "pdf") {
        iconFile = <FilePdfOutlined />;
    }
    if (file_type === "doc" || file_type === "docx") {
        iconFile = <FileWordOutlined />;
    }
    if (
        [
            "jpg",
            "bmp",
            "dib",
            "jpe",
            "jfif",
            "gif",
            "tif",
            "tiff",
            "png",
            "heic",
        ].includes(file_type)
    ) {
        iconFile = <FileImageOutlined />;
    }
    // if (file_type === "rar" || file_type === "zip") {
    //     iconFile = <FileZipOutlined  />;
    // }
    if (file_type === "xlsx" || file_type === "xls") {
        iconFile = <FileExcelOutlined />;
    }
    const shareData = {
        title: "MDN",
        text: "Learn web development on MDN!",
        url: "https://developer.mozilla.org",
    };
    const viewFile = findViewFile(file, file_id, file_type, file_name);
    const handelShare = () => {
        if (navigator.canShare) {
            navigator
                .share({
                    title: file_name,
                    url: viewFile,
                })
                .then(() => console.log("Share was successful."))
                .catch((error) => console.log("Sharing failed", error));
        }
    };
    return (
        <>
            <div
                // style={{ color: "#0075FF", cursor: "pointer" }}
                onClick={handleClickOpen}
                className="flex text-[#0075FF] "
                style={{
                    display: "flex",
                    alignItems: "start",
                    gap: 10,
                    color: "#0075FF",
                    marginBottom: 10,
                }}
            >
                <span style={{ display: "inline-block", marginTop:1 }}>
                    {!props.noIcon && iconFile}
                </span>
                <span>{file_name}</span>
            </div>

            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <div className="px-5 mt-[14px] ">
                    <div>
                        <Toolbar sx={{ px: 0 }}>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography
                                sx={{ ml: 1, flex: 1 }}
                                variant="h6"
                                component="div"
                            >
                                <div className="text-[28px] leading-[29px] font-bold text-[#28353B]">
                                    {" "}
                                    {file_name}
                                </div>
                            </Typography>
                        </Toolbar>
                    </div>
                    <List className="mb-[70px] min-h-screen">
                        <PDFViewer
                            fileId={file_id}
                            fileType={getExtensionFile(file_name)}
                            fileName={file_name}
                        />
                    </List>
                </div>
                <footer className="sticky bottom-0 bg-white px-5 py-[15px] shadow-[0px_0px_8px_rgba(0,0,0,0.25)] flex gap-7 items-center">
                    <button
                        onClick={() => {
                            if (noAction) return;
                            if (deleted) return;
                            if (isFileVIMCToTruc)
                                return fileStore.handleDownloadAttachmentTruc(
                                    file_id,
                                    file_name
                                );
                            if (isFileTruc)
                                return fileStore.handleDownloadFileTruc(
                                    file_id,
                                    file_name
                                );
                            return fileStore.handleDownloadFile(
                                file_id,
                                file_name
                            );
                        }}
                        className="text-center text-white rounded bg-primary py-[9px] w-full"
                    >
                        <div className="font-semibold text-[14px] leading-[22px]">
                            Tải xuống
                        </div>
                    </button>
                    <ShareIos onClick={handelShare} />
                </footer>
            </Dialog>
        </>
    );
};

FileItem.propTypes = {};

export default FileItem;
